'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagZmAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M27.999 0H-0.000976562V20H27.999V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M27.999 0H-0.000976562V20H27.999V0Z", fill: "#2A8815" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21.593 4.83191C21.593 4.83191 21.0555 5.03587 20.4816 4.83191C20.0249 4.66961 19.5657 4.12055 19.1884 3.92981C18.9697 3.81923 19.3756 3.29212 18.9427 3.43437C18.5097 3.57662 17.8025 2.91573 17.8025 2.91573C17.8025 2.91573 17.0719 2.02519 18.1481 2.02519C19.2242 2.02519 21.4942 2.79838 21.4942 2.79838C21.4942 2.79838 21.5792 2.39908 21.7643 2.21505C21.9494 2.03102 22.0866 1.86195 22.3899 1.90784C22.6932 1.95373 22.8609 2.38098 22.8609 2.38098L22.3899 2.56075V2.91573C22.3899 2.91573 25.5384 1.95015 26.2826 2.02519C27.0268 2.10023 26.4278 2.91674 25.9785 3.43437C25.8048 3.63459 25.2373 4.04253 24.8924 3.71546C24.5474 3.38839 24.6754 4.06907 24.3178 4.28882C23.7347 4.64719 23.5158 4.97562 23.3154 5.07117C23.1149 5.16672 22.6765 5.07117 22.6765 5.07117L22.8046 5.39986C22.8046 5.39986 22.8405 5.79492 22.6765 5.95244C22.5125 6.10996 22.3984 6.22105 21.9987 6.17387C21.599 6.12669 21.4104 6.227 21.2775 5.78732C21.1445 5.34763 21.593 4.83191 21.593 4.83191ZM21.9223 4.37651V5.40515L22.3745 5.02698L21.9223 4.37651Z",
          fill: "#EF8A34"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M27.999 8H23.999V20H27.999V8Z", fill: "#F48D36" }),
      /* @__PURE__ */ jsx("path", { d: "M23.999 8H19.999V20H23.999V8Z", fill: "#262626" }),
      /* @__PURE__ */ jsx("path", { d: "M19.999 8H15.999V20H19.999V8Z", fill: "#EC322B" })
    ]
  }
);
const VpFlagZmAsset = forwardRef(FlagZmAsset);

export { VpFlagZmAsset as default };
